module.exports = {
      id: "sharechat-usage",
      viewBox: "0 0 29.14 29.14",
      url: "/" + "sprite-6d93c42890617d6f6477c703e3b36dd9.svg#sharechat",
      toString: function () {
        return this.url;
      }
    }